import { useSearchParams, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Button,
} from '@chakra-ui/react'
import { MdCheckCircle, MdError } from 'react-icons/md'
import { axios } from '@/lib/axios'

const DirectApproveDamexPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token')

  const { data, isPending, isError, error } = useQuery({
    queryKey: ['directApproveDamex', token],
    queryFn: async () => {
      if (!token) {
        throw new Error('Missing approval token. Please use the link from your email.')
      }

      const response = await axios.put('/offers/damex/direct-approve', {
        token,
      })

      if (response.data.success) {
        return response.data.data
      } else {
        throw new Error(123)
      }
    },
    enabled: !!token,
    retry: false,
  })

  const offerId = data?.offerId

  const errorMessage = error?.message || ''

  const handleViewOffer = () => {
    if (offerId) {
      navigate(`/offers/${offerId}`)
    }
  }

  const handleBackHome = () => {
    navigate('/')
  }

  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="stretch">
        <Box textAlign="center">
          <Heading size="xl" mb={2}>
            Damex Direct Approval
          </Heading>
        </Box>

        {isPending && (
          <Box textAlign="center" py={10}>
            <Spinner size="xl" color="blue.500" thickness="4px" mb={4} />
            <Text fontSize="lg" color="gray.600">
              Processing your approval...
            </Text>
            <Text fontSize="sm" color="gray.500" mt={2}>
              Please wait while we verify and process your request.
            </Text>
          </Box>
        )}

        {!isPending && !isError && (
          <Alert
            status="success"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            minH="300px"
            borderRadius="lg"
          >
            <MdCheckCircle size="50px" color="green" style={{ marginBottom: '16px' }} />
            <AlertTitle mt={4} mb={1} fontSize="2xl">
              Approval Successful!
            </AlertTitle>
            <AlertDescription maxWidth="sm" fontSize="md" mt={2}>
              The Damex document has been successfully approved. The offer will be updated accordingly.
            </AlertDescription>
            <VStack spacing={3} mt={6}>
              {offerId && (
                <Button colorScheme="blue" size="lg" onClick={handleViewOffer}>
                  View Offer
                </Button>
              )}
              <Button variant="outline" onClick={handleBackHome}>
                Back to Home
              </Button>
            </VStack>
          </Alert>
        )}

        {isError && (
          <Alert
            status="error"
            variant="subtle"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            minH="300px"
            borderRadius="lg"
          >
            <MdError size="50px" color="red" style={{ marginBottom: '16px' }} />
            <AlertTitle mt={4} mb={1} fontSize="2xl">
              Approval Failed
            </AlertTitle>
            {/* <AlertDescription maxWidth="sm" fontSize="md" mt={2}>
              {errorMessage}
            </AlertDescription> */}
            <VStack spacing={3} mt={6}>
              <Button colorScheme="blue" variant="outline" onClick={handleBackHome}>
                Back to Home
              </Button>
            </VStack>
          </Alert>
        )}
      </VStack>
    </Container>
  )
}

export default DirectApproveDamexPage
